
common.View.create('website::layouts.main.Slider', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        let swiperElement = this.element.find('.swiper-container');
        let swiperManualDisabled = false;
        
        const swiper = new Swiper(swiperElement.get(0), {
            roundLengths: true,

            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            },
            
            // If you want pagination
            pagination: {
                el: this.element.find('.swiper-pagination').get(0),
                clickable: true,
            },
        });

        const autoplayToggleButton = this.element.find('#autoplayToggle');
        autoplayToggleButton.on('click', () => {
            if (!swiperManualDisabled) {
                swiper.autoplay.stop();
                autoplayToggleButton.html('<i class="fas fa-play"></i>'); // change to play icon
                swiperManualDisabled = true;
            } else {
                swiper.autoplay.start();
                autoplayToggleButton.html('<i class="fas fa-pause"></i>'); // change to pause icon
                swiperManualDisabled = false;
            }
        });

        swiperElement
            .on('mouseenter', function() {
                if( !swiperManualDisabled )
                    swiper.autoplay.stop();
            }).on('mouseleave', function() {
                if( !swiperManualDisabled )
                    swiper.autoplay.start();
            }).on('focusin', function() {
                if( !swiperManualDisabled )
                    swiper.autoplay.stop();
            }).on('focusout', function() {
                if( !swiperManualDisabled )
                    swiper.autoplay.start();
            });
            
        this.element.on('focusin focusout', '*', function() {
            swiper.autoplay.stop();
        });
    }
});
